import React, {forwardRef} from 'react'
import {CheckboxBase} from './checkbox-base'
import {TriCheckboxNewProps} from './types'

export const TriCheckboxNew = forwardRef(
  (props: TriCheckboxNewProps, ref: React.Ref<HTMLInputElement>) => (
    <CheckboxBase
      {...props}
      ref={ref}
      onClick={e => props.onChange?.(!props.value, e)}
    />
  )
)
